import styled from 'styled-components';
import { TwitterEmbedStoryblok } from '@/types/generated/storyblok/schema';

export const StyledTweetEmbed = styled.div<
    Pick<TwitterEmbedStoryblok, 'align'>
>`
    display: flex;
    justify-content: ${({ align }) => align};
`;
